import React from 'react';

const InfoModal = ({ isOpen, onClose, title, message }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex justify-center items-center">
      <div className="relative mx-auto p-5 border w-full max-w-md shadow-lg rounded-md bg-white">
        <div className="mt-3">
          <h3 className="text-lg leading-6 font-medium text-gray-900 text-center mb-4">{title}</h3>
          <div className="mt-2 px-7 py-3 bg-gray-50 rounded-md">
            <p className="text-sm text-gray-700 whitespace-pre-wrap">{message}</p>
          </div>
          <div className="items-center px-4 py-3 mt-4 text-center">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-jims-cyan text-white rounded hover:bg-jims-cyan-dark transition duration-300"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoModal;
